
const currentHostUrl = 'https://etp.carplaza.kz'

const MAIN_API = currentHostUrl + ':8085'

export { MAIN_API }
